module.exports = __webpack_public_path__ + "img/star-s.e3dcd4a9.svg";